module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-data"
  }, [_c('div', {
    staticClass: "school-data__header"
  }, [_c('div', {
    staticClass: "school-data__header__left"
  }, [_c('h1', [_vm._v("Vikarkontinuitet")]), _vm._v(" "), _c('changeSchoolYear', {
    staticClass: "marg-1-right",
    attrs: {
      "white-theme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "school-data__header__right"
  }, [(!_vm.isDatesPristine) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n      Viser for hver klasse og hvert fag, hvor mange forskellige vikarer der har dækket, og hvor stor en andel af vikartimerne den mest brugte vikar har haft.\n      En høj andel betyder, at det i høj grad er den samme vikar, der underviser.\n    ")]), _vm._v(" "), (_vm.klassRows.length < 1) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen vikartimer i perioden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.klassRows), function(klass) {
    return _c('table', {
      key: klass.name,
      staticClass: "d-table"
    }, [_c('thead', [_c('tr', {
      staticClass: "d-table__klass",
      on: {
        "click": function($event) {
          return _vm.toggleKlass(klass.name)
        }
      }
    }, [_c('th', [_c('span', {
      class: _vm.openKlasses.indexOf(klass.name) > -1 ? 'icon-arrow-down4' : 'icon-arrow-right4'
    }), _vm._v("\n          " + _vm._s(klass.name) + "\n        ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.formatHours(klass.minutes)) + " vikartimer")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(klass.substitutes.length) + " vikarer")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(klass.topSubstitute.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.formatPercent(klass.topSubstitute.minutes, klass.minutes)))])]), _vm._v(" "), (_vm.openKlasses.indexOf(klass.name) > -1) ? _c('tr', {
      staticClass: "d-table__columns"
    }, [_c('th', [_vm._v("Fag")]), _vm._v(" "), _c('th', [_vm._v("Vikartimer")]), _vm._v(" "), _c('th', [_vm._v("Antal vikarer")]), _vm._v(" "), _c('th', [_vm._v("Mest brugte vikar")]), _vm._v(" "), _c('th', [_vm._v("Andel for mest brugte vikar")])]) : _vm._e()]), _vm._v(" "), (_vm.openKlasses.indexOf(klass.name) > -1) ? _c('tbody', _vm._l((klass.subjects), function(subject) {
      return _c('tr', {
        key: subject.name
      }, [_c('td', [_vm._v(_vm._s(subject.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatHours(subject.minutes)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject.substitutes.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject.topSubstitute.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPercent(subject.topSubstitute.minutes, subject.minutes)))])])
    }), 0) : _vm._e()])
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eca5c450!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolData/SchoolDataSubContinuity.vue
// module id = 2155
// module chunks = 1